// extracted by mini-css-extract-plugin
export var icon = "_s5-0";